import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface SuggestionItem {
  id: string;
  name: string;
  description: string;
  score: number;
  matched_keys: string[];
  reason: 'nome similar' | 'chaves similares' | 'nome e chaves similares';
}

export interface PopularEvent {
  id: string;
  name: string;
  description: string;
  usage_count: number;
}

export interface SuggestionResponse {
  success: boolean;
  data: SuggestionItem[];
}

export interface PopularEventsResponse {
  success: boolean;
  data: PopularEvent[];
}

@Injectable({
  providedIn: 'root',
})
export class IntegrationTemplateSuggestionService {
  private apiUrl = `${environment.apiUrl}/integration-templates`;

  constructor(private http: HttpClient) {}

  /**
   * Sugere templates similares baseado em nome e/ou chaves do schema.
   * @param name Nome do template (opcional)
   * @param keys Chaves do schema (opcional)
   * @returns Observable com sugestões de templates similares
   */
  suggest(name?: string, keys?: string[]): Observable<SuggestionResponse> {
    let params = new HttpParams();

    if (name) {
      params = params.set('name', name);
    }

    if (keys && keys.length > 0) {
      keys.forEach((key) => {
        params = params.append('keys[]', key);
      });
    }

    return this.http.get<SuggestionResponse>(`${this.apiUrl}/suggest`, { params }).pipe(
      catchError((err) => {
        console.error('Suggest failed:', err);
        return of({ success: false, data: [] });
      })
    );
  }

  /**
   * Retorna eventos/listas mais populares em um nicho específico.
   * @param nicho Tipo de operação (ex: INFOPRODUTO, ECOMMERCE)
   * @returns Observable com lista de eventos populares
   */
  popularEventsByNicho(nicho?: string): Observable<PopularEventsResponse> {
    let params = new HttpParams();

    if (nicho) {
      params = params.set('nicho', nicho);
    }

    return this.http.get<PopularEventsResponse>(`${this.apiUrl}/popular-events`, { params }).pipe(
      catchError((err) => {
        console.error('Popular events failed:', err);
        return of({ success: false, data: [] });
      })
    );
  }
}
